<template>
    <div>
        <h4>404 route</h4>
    </div>    
</template>

<script>
export default {}
</script>

<style scoped>
</style>